<link rel="ractive" href="./tls-details.html" name="c-gp-tls-details">
<link rel="ractive" href="./dot-loader.html" name="c-dot-loader">

<div class="c-gp-results-raw-output {{#if allowResultsBlockShrink}}is-height-shrink-enabled{{/if}}">
	<div class="c-gp-results-raw-output_list {{#if testInProgress}}round-bottom{{/if}}" on-scroll="@this.hideSetLocationButton(@event)">
		{{#each preparedTestResults}}
			<div class="c-gp-results-raw-output_list_item item-id-{{this.clientSideId}}"
				{{#if showSetLocationButton}}
					tabindex="0"
					role="button"
					aria-label="Set as location for the next test"
					on-focus="@this.enableItemFocused(@event, this.clientSideId)"
					on-blur="@this.hideSetLocationButton(@event)"
					on-keydown="@this.headerKeydownHandler(@event, this.clientSideId)"
					on-mouseenter="@this.showSetLocationButton(this.clientSideId)"
					on-mouseleave="@this.hideSetLocationButton(@event)"
				{{/if}}
			>
				<div class="c-gp-results-raw-output_list_item_header">
					<div class="c-gp-results-raw-output_list_item_header_info {{#if @this.shouldUseOverflowLayout(this)}}is-overflow-layout{{/if}}"
						style="border-left: 6px solid {{@this.getStatusColor(this.statsPerTarget[activeTargetIdx])}}; background: linear-gradient(to right, {{@this.getStatusColor(this.statsPerTarget[activeTargetIdx])}}0C, transparent 50%);"
					>
						<div class="c-gp-results-raw-output_list_item_header_info_entity">
							<span class="c-gp-results-raw-output_list_item_header_info_entity_field">
								<img height="16" width="16" alt="" src="{{@shared.assetsHost}}/img/gp-logo.svg"/>
								<span>AS{{this.asn}}</span>
							</span>

							<span class="c-gp-results-raw-output_list_item_header_info_entity_field">
								<img width="21" height="14" alt="" src="https://cdn.jsdelivr.net/npm/country-flag-icons@1.5.5/3x2/{{this.country}}.svg">
								<span>{{this.city}}, {{#if this.state}}{{this.state}}, {{/if}}{{this.country}}</span>
							</span>

							<span class="c-gp-results-raw-output_list_item_header_info_entity_field">
								{{#if !@this.logoError(this.asn)}}
									<img width="18"
										height="18"
										alt=""
										src="/asn-logo/AS{{this.asn}}?v={{@shared.assetsVersion}}&size=36&padding=0"
										on-load="@this.set('showingNetworkLogos', true)"
										on-error="@this.setLogoError(this.asn)">
								{{else}}
									<span class="c-gp-results-raw-output_list_item_header_info_entity_logo-placeholder">
										{{this.network[0]}}
									</span>
								{{/if}}
								<span>{{this.network}}</span>
							</span>
						</div>

						{{#if this.statsPerTarget[activeTargetIdx].ipAddr}}
							<span class="c-gp-results-raw-output_list_item_header_info_arrow"></span>

							<c-gp-tls-details tls="{{this.statsPerTarget[activeTargetIdx].tls}}" screenWidth="{{screenWidth}}"></c-gp-tls-details>

							<div class="c-gp-results-raw-output_list_item_header_info_entity">
								<span class="c-gp-results-raw-output_list_item_header_info_entity_field">
									<i class="fa fa-server" aria-hidden="true"></i>
									<span>{{this.statsPerTarget[activeTargetIdx].ipAddr}}</span>
								</span>

								{{#if @this.isAnycastIp(this.statsPerTarget[activeTargetIdx].ipAddr) || @this.getIpLocationLabel(this.statsPerTarget[activeTargetIdx].ipAddr)}}
									<span class="c-gp-results-raw-output_list_item_header_info_entity_field">
										{{#if @this.isAnycastIp(this.statsPerTarget[activeTargetIdx].ipAddr)}}
											<img width="22" height="16" alt="" src="{{@shared.assetsHost}}/img/anycast.svg">
											Anycast
										{{else}}
											{{#if @this.getIpLocationCountryCode(this.statsPerTarget[activeTargetIdx].ipAddr)}}
												<img width="21" height="14" alt="" src="https://cdn.jsdelivr.net/npm/country-flag-icons@1.5.5/3x2/{{@this.getIpLocationCountryCode(this.statsPerTarget[activeTargetIdx].ipAddr)}}.svg">
											{{/if}}
											<span>{{@this.getIpLocationLabel(this.statsPerTarget[activeTargetIdx].ipAddr)}}</span>
										{{/if}}
									</span>
								{{elseif @this.isTargetNetworkInfoLoading(this.statsPerTarget[activeTargetIdx].ipAddr)}}
									<span class="c-gp-results-raw-output_list_item_header_info_entity_field">
										<span class="c-gp-results-raw-output_list_item_header_info_entity_loading-placeholder"></span>
									</span>
								{{/if}}

								{{#if @this.getNetworkName(this.statsPerTarget[activeTargetIdx].ipAddr)}}
									<span class="c-gp-results-raw-output_list_item_header_info_entity_field">
										{{#if @this.getNetworkAsnByIp(this.statsPerTarget[activeTargetIdx].ipAddr) && !@this.logoError(@this.getNetworkAsnByIp(this.statsPerTarget[activeTargetIdx].ipAddr))}}
											<img width="18"
												height="18"
												src="/asn-logo/{{@this.getNetworkAsnByIp(this.statsPerTarget[activeTargetIdx].ipAddr)}}?v={{@shared.assetsVersion}}&size=36&padding=0"
												alt="{{@this.getNetworkName(this.statsPerTarget[activeTargetIdx].ipAddr)}} logo"
												on-error="@this.setLogoError(@this.getNetworkAsnByIp(this.statsPerTarget[activeTargetIdx].ipAddr))">
										{{else}}
											<span class="c-gp-results-raw-output_list_item_header_info_entity_logo-placeholder">
												{{@this.getNetworkName(this.statsPerTarget[activeTargetIdx].ipAddr)[0]}}
											</span>
										{{/if}}
										<span>{{@this.getNetworkName(this.statsPerTarget[activeTargetIdx].ipAddr)}}</span>
									</span>
								{{elseif @this.isTargetNetworkInfoLoading(this.statsPerTarget[activeTargetIdx].ipAddr)}}
									<span class="c-gp-results-raw-output_list_item_header_info_entity_field">
										<span class="c-gp-results-raw-output_list_item_header_info_entity_loading-placeholder"></span>
									</span>
								{{/if}}
							</div>
						{{/if}}
					</div>

					<div class="c-gp-results-raw-output_list_item_header_metrics-controls">
						{{#if !this.statsPerTarget[activeTargetIdx].rawOutput}}
							<c-dot-loader></c-dot-loader>
						{{else}}
							<div class="c-gp-results-raw-output_list_item_header_metrics-controls_metrics">
								{{#each @this.getHeaderPrimaryMetrics(this.statsPerTarget[activeTargetIdx].extraValues)}}
									<span class="c-gp-results-raw-output_list_item_header_metrics-controls_metric">
										{{this.text}}
										<b>{{this.value}}{{this.units}}</b>
									</span>
								{{/each}}

								{{#if _.getGpTargetTiming(this.statsPerTarget[activeTargetIdx])}}
									<span class="c-gp-results-raw-output_list_item_header_metrics-controls_metric">
										Time
										<b>
											{{_.getGpTargetTiming(this.statsPerTarget[activeTargetIdx])}}
										</b>
									</span>
								{{/if}}

								{{#unless this.statsPerTarget[activeTargetIdx].isFailed || this.statsPerTarget[activeTargetIdx].avgTiming === PROBE_STATUS_OFFLINE}}
									{{#each @this.getHeaderSecondaryMetrics(this.statsPerTarget[activeTargetIdx].extraValues)}}
										<span class="c-gp-results-raw-output_list_item_header_metrics-controls_metric">
											{{this.text}}
											<b>{{this.value}}{{this.units}}</b>
										</span>
									{{/each}}
								{{/unless}}
							</div>

							<button on-click="@this.hideShowTestResult(this.clientSideId)"
								role="button"
								aria-label="{{#if hiddenTestResults[activeTargetIdx].includes(this.clientSideId)}}Expand{{else}}Collapse{{/if}} output"
								class="c-gp-results-raw-output_list_item_header_metrics-controls_dropdown">
								<i class="fa fa-chevron-{{#if hiddenTestResults[activeTargetIdx].includes(this.clientSideId)}}down{{else}}up{{/if}}" aria-hidden="true"/>
							</button>
						{{/if}}
					</div>
				</div>

				{{#if this.statsPerTarget[activeTargetIdx].rawOutput}}
					<div class="c-gp-results-raw-output_list_item_output">
						<pre class="{{#if hiddenTestResults[activeTargetIdx].includes(this.clientSideId)}}hide-code{{/if}}">{{this.statsPerTarget[activeTargetIdx].rawOutput}}</pre>
						{{#if hiddenTestResults[activeTargetIdx].includes(this.clientSideId)}}
							<button type="button"
								tabindex="-1"
								class="c-gp-results-raw-output_list_item_expand-output"
								on-click="@this.hideShowTestResult(this.clientSideId)"
								aria-label="Click to expand">
								<span>Click to expand</span>
							</button>
						{{/if}}

						{{#if this.statsPerTarget[activeTargetIdx].responseBody && !hiddenTestResults[activeTargetIdx].includes(this.clientSideId)}}
							{{#if @this.isResponseBodyHidden(this)}}
								<button type="button"
									class="c-gp-results-raw-output_list_item_content-toggle"
									on-click="expandAllRawOutput({ responseBodyOnly: true })"
									aria-label="Show response bodies">
									<i class="fa fa-chevron-down" aria-hidden="true"/>
									Show response bodies
								</button>
							{{/if}}
							<br>
							<pre class="{{#if @this.isResponseBodyHidden(this)}}hide-code{{/if}} response-body">{{this.statsPerTarget[activeTargetIdx].responseBody}}</pre>
						{{elseif testInProgress === false && isInfiniteModeRes}}
							<pre class="{{#if hiddenTestResults[activeTargetIdx].includes(this.clientSideId)}}hidden{{/if}}">{{this.statsPerTarget[activeTargetIdx].rawFooter}}</pre>
						{{/if}}
					</div>
				{{/if}}
			</div>
		{{/each}}
	</div>

	{{#if showSetLocationButton && floatingSetLocationButton.visible}}
		<div class="c-gp-results-raw-output_set-location-hitarea"
			style="top: {{floatingSetLocationButton.top}}px; left: {{floatingSetLocationButton.left-4}}px; height: {{floatingSetLocationButton.height}}px;"
			on-mouseleave="@this.hideSetLocationButton(@event)">
			<button class="c-gp-results-raw-output_set-location {{#if itemFocused}}focus-outline{{/if}}"
				type="button"
				tabindex="-1"
				style="top: {{floatingSetLocationButton.buttonTop}}px;"
				as-tooltip="'Set as location for the next test', 'right'"
				on-focus="@this.set('itemFocused', true)"
				on-blur="@this.hideSetLocationButton(@event)"
				on-click="@this.setProbeAsLocation()"
				aria-label="Set as location for the next test">
				<i class="fa fa-map-marker" aria-hidden="true"></i>
			</button>
		</div>
	{{/if}}
</div>

<script>
	const _ = require('../../assets/js/_');
	const http = require('../../assets/js/utils/http');
	const listeners = require('../../assets/js/utils/listeners');
	const tooltip = require('../../assets/js/decorators/tooltip');
	const PROBE_STATUS_FAILED = _.getProbeStatusFailedValue();
	const PROBE_STATUS_OFFLINE = _.getProbeStatusOfflineValue();
	const MIN_OUTPUT_HEIGHT = 400;

	component.exports = {
		decorators: {
			tooltip,
		},
		data () {
			return {
				_,
				activeTargetIdx: 0,
				hiddenTestResults: {
					0: [],
					1: [],
				},
				hiddenResponseBodies: {
					0: [],
					1: [],
				},
				networkDataByIp: Object.create(null),
				logoErrors: new Set(),
				networkLookupsActive: false,
				PROBE_STATUS_FAILED,
				PROBE_STATUS_OFFLINE,
				pendingNetworkLookups: new Set(),
				showingNetworkLogos: false,
				allowResultsBlockShrink: false,
				resultsBlockHeightShapeSignature: null,
				skipNextResize: false,
				headerInfoCharWidths: null,
				headerInfoFallbackCharWidth: 7,
				headerInfoListWidth: 0,
				headerInfoOverflowByResultId: new Set(),
				headerInfoEntityWidthsByKey: new Map(),
				floatingSetLocationButton: {
					visible: false,
					top: 0,
					left: 0,
					height: 0,
					buttonTop: 0,
					clientSideId: null,
					probeData: null,
				},
				showSetLocationButton: true,
				itemFocused: false,
				justFocusedItem: false,
			};
		},
		computed: {
			responseBodyCharsPerLine () {
				let listWidth = this.get('headerInfoListWidth') || 0;
				let outputHorizontalPadding = 32 * 2;
				let outputListMargin = 24 * 2;

				let contentWidth = listWidth
					? Math.max(1, listWidth - outputHorizontalPadding)
					: Math.min(1240, window.innerWidth - outputListMargin - outputHorizontalPadding);

				let charWidth = this.get('responseBodyCharWidth') || 7;
				return Math.max(1, Math.floor(contentWidth / charWidth));
			},
			headerInfoAvailableHalfWidth () {
				let listWidth = this.get('headerInfoListWidth') || 0;
				let containerHorizontalPadding = 24 * 2;
				let containerWidth = listWidth - containerHorizontalPadding;
				let arrowMinWidth = 110;
				let arrowMarginRight = 32;
				return (containerWidth / 2) - ((arrowMinWidth + arrowMarginRight) / 2);
			},
		},
		onrender () {
			if (!Ractive.isServer) {
				this.set('networkLookupsActive', true);

				this._resizeHeaderInfoHandler = () => {
					this.recalculateHeaderInfoLayoutStates();
				};

				this.initHeaderInfoCharWidths();
				this.recalculateHeaderInfoLayoutStates();
				listeners.addManagedListener(this, window, 'resize', this._resizeHeaderInfoHandler);

				// open a specific item if it was scrolled to from the parent component
				this.observe('scrolledToResId', (clientSideId) => {
					if (clientSideId === null) { return; }

					let activeTargetIdx = this.get('activeTargetIdx');
					let hiddenTestResults = this.get(`hiddenTestResults[${activeTargetIdx}]`);
					let targetId = hiddenTestResults.find(resId => resId === clientSideId);

					if (typeof targetId === 'number') {
						if (this.get('allowResultsBlockShrink')) {
							this.set('skipNextResize', true);
						}

						this.hideShowTestResult(targetId);
					}

					this.set('scrolledToResId', null);
				}, { init: false });

				this.observe('preparedTestResults testInProgress', () => {
					this.resetHeaderInfoEntityWidthCache();
					this.populateNetworkData();

					this.recalculateHeaderInfoLayoutStates({
						allowShrink: this.shouldAllowResultsBlockShrink(),
					});

					requestAnimationFrame(() => {
						this.hideSetLocationButtonIfMoved();
					});
				}, { deep: true, defer: true });

				this.observe('hiddenTestResults', () => {
					if (this.get('skipNextResize')) {
						this.set('skipNextResize', false);
						return;
					}

					this.setResultsBlockHeight({ allowShrink: false });
				}, { deep: true, defer: true, init: false });

				this.observe('hiddenResponseBodies', () => {
					this.setResultsBlockHeight({ allowShrink: false });
				}, { deep: true, defer: true, init: false });

				this.observe('activeTargetIdx', () => {
					this.resetHeaderInfoEntityWidthCache();
					this.populateNetworkData();
					this.recalculateHeaderInfoLayoutStates({ allowShrink: false });
				});

				this.observe('sortOrder sortBy activeTargetIdx', () => {
					let listEl = this.find('.c-gp-results-raw-output_list');

					if (listEl) {
						listEl.scrollTop = 0;
					}

					this.recalculateHeaderInfoLayoutStates();
				}, { init: false });

				this._onSetLocationViewportChange = (event) => {
					this.hideSetLocationButton(event);
				};

				this._setLocationListEl = this.find('.c-gp-results-raw-output_list');
				listeners.addManagedListener(this, window, 'resize', this._onSetLocationViewportChange);
				listeners.addManagedListener(this, window, 'scroll', this._onSetLocationViewportChange);

				if (this._setLocationListEl) {
					listeners.addManagedListener(this, this._setLocationListEl, 'scroll', this._onSetLocationViewportChange);
				}
			}
		},
		onunrender () {
			this.set('networkLookupsActive', false);

			if (this.pendingNetworkDataUpdatesFlushTimeout) {
				clearTimeout(this.pendingNetworkDataUpdatesFlushTimeout);
				this.pendingNetworkDataUpdatesFlushTimeout = null;
			}

			if (this.pendingResultsBlockHeightFrame) {
				cancelAnimationFrame(this.pendingResultsBlockHeightFrame);
				this.pendingResultsBlockHeightFrame = null;
				this.pendingResultsBlockHeightAllowShrink = false;
			}
		},
		// --- set location button logic ---
		isSetLocationFocusActive (setLocationButton) {
			let activeElement = document.activeElement;

			return (setLocationButton && setLocationButton.contains(activeElement))
				|| activeElement?.classList.contains('c-gp-results-raw-output_list_item');
		},
		showSetLocationButton (clientSideId) {
			if (!this.get('showSetLocationButton')) { return; }

			let probeData = this.get('preparedTestResults').find(item => item.clientSideId === clientSideId);
			let node = document.querySelector(`.item-id-${clientSideId}`);
			let nodeHeader = node?.querySelector('.c-gp-results-raw-output_list_item_header_info');
			let container = this.find('.c-gp-results-raw-output');
			let listContainer = this.find('.c-gp-results-raw-output_list');

			this.set('itemFocused', false);

			if (!node || !nodeHeader || !container || !listContainer) { return; }

			let listRect = listContainer.getBoundingClientRect();
			let nodeHeaderRect = nodeHeader.getBoundingClientRect();
			let visibilityOverflowTolerancePx = 15;
			let isNodeHeaderFullyVisible = nodeHeaderRect.top >= (listRect.top - visibilityOverflowTolerancePx)
				&& nodeHeaderRect.bottom <= (listRect.bottom + visibilityOverflowTolerancePx);

			if (!isNodeHeaderFullyVisible) {
				this.set('floatingSetLocationButton.visible', false);
				return;
			}

			let nodeRect = node.getBoundingClientRect();
			let containerRect = container.getBoundingClientRect();
			let nodeHeaderHeight = nodeHeaderRect.height;

			let relativeTop = nodeRect.top - containerRect.top;
			let relativeLeft = nodeRect.left - containerRect.left;

			this.set('floatingSetLocationButton', {
				visible: true,
				clientSideId,
				probeData,
				top: relativeTop,
				left: relativeLeft - 26,
				height: nodeRect.height,
				buttonTop: nodeHeaderHeight / 2 - 13,
			});
		},
		hideSetLocationButtonIfMoved () {
			let floatingSetLocationButton = this.get('floatingSetLocationButton');

			if (!floatingSetLocationButton.visible) {
				return;
			}

			let node = this.find(`.item-id-${floatingSetLocationButton.clientSideId}`);
			let nodeHeader = node?.querySelector('.c-gp-results-raw-output_list_item_header_info');
			let container = this.find('.c-gp-results-raw-output');

			if (!node || !nodeHeader || !container) {
				this.set('itemFocused', false);
				this.set('floatingSetLocationButton.visible', false);
				return;
			}

			let nodeRect = node.getBoundingClientRect();
			let nodeHeaderRect = nodeHeader.getBoundingClientRect();
			let containerRect = container.getBoundingClientRect();
			let top = nodeRect.top - containerRect.top;
			let left = nodeRect.left - containerRect.left - 26;
			let height = nodeRect.height;
			let buttonTop = nodeHeaderRect.height / 2 - 13;

			if (top !== floatingSetLocationButton.top
				|| left !== floatingSetLocationButton.left
				|| height !== floatingSetLocationButton.height
				|| buttonTop !== floatingSetLocationButton.buttonTop) {
				this.set('itemFocused', false);
				this.set('floatingSetLocationButton.visible', false);
			}
		},
		hideSetLocationButton (event) {
			if (!this.get('showSetLocationButton')) { return; }

			if (this.get('justFocusedItem')) {
				if (event?.type !== 'scroll') {
					this.set('justFocusedItem', false);
				}

				return;
			}

			if (event?.type === 'scroll') {
				this.set('itemFocused', false);
				this.set('floatingSetLocationButton.visible', false);
				return;
			}

			let setLocationButton = this.find('.c-gp-results-raw-output_set-location');
			let setLocationHitarea = this.find('.c-gp-results-raw-output_set-location-hitarea');

			if (event?.type === 'blur' && !event.relatedTarget) {
				requestAnimationFrame(() => {
					this.hideSetLocationButton();
				});

				return;
			}

			if (this.isSetLocationFocusActive(setLocationButton)) {
				return;
			}

			if (event?.type === 'blur' && setLocationButton?.contains(event.relatedTarget)) {
				return;
			}

			if (event && event.relatedTarget && event.type !== 'blur') {
				let container = event.target.closest('.c-gp-results-raw-output_list_item');
				let relatedContainer = event.relatedTarget.closest?.('.c-gp-results-raw-output_list_item');

				if ((container && container.contains(event.relatedTarget))
					|| relatedContainer
					|| (setLocationHitarea && setLocationHitarea.contains(event.relatedTarget))) {
					return;
				}
			}

			this.set('itemFocused', false);
			this.set('floatingSetLocationButton.visible', false);
		},
		setProbeAsLocation (probeData = this.get('floatingSetLocationButton.probeData')) {
			if (!this.get('showSetLocationButton') || !probeData) { return; }

			this.set('currSearchLocation', `AS${probeData.asn}+${probeData.city}`);
			this.set('floatingSetLocationButton.visible', false);
		},
		enableItemFocused (event, clientSideId) {
			if (!this.get('showSetLocationButton')) { return; }

			if (!event.target?.classList.contains('c-gp-results-raw-output_list_item')) {
				return;
			}

			this.showSetLocationButton(clientSideId);
			this.set('itemFocused', true);
			this.set('justFocusedItem', true);

			requestAnimationFrame(() => {
				this.set('justFocusedItem', false);
			});
		},
		headerKeydownHandler (event, clientSideId) {
			if (!this.get('showSetLocationButton')) { return; }

			if (!event.target?.classList.contains('c-gp-results-raw-output_list_item')) {
				return;
			}

			if (event.key === 'Enter' || event.key === ' ') {
				event.preventDefault();
				let probeData = this.get('preparedTestResults').find(item => item.clientSideId === clientSideId);
				this.setProbeAsLocation(probeData);
			}
		},
		// --- Logic to determine whether to (always) show the HTTP response body ---
		isResponseBodyHidden (result) {
			let activeTargetIdx = this.get('activeTargetIdx');
			let body = result?.statsPerTarget?.[activeTargetIdx]?.responseBody || '';

			if (!_.shouldCollapseResponseBody(body, this.get('responseBodyCharsPerLine'))) {
				return false;
			}

			let hidden = this.get(`hiddenResponseBodies[${activeTargetIdx}]`) ?? [];
			return hidden.includes(result?.clientSideId);
		},
		// --- Output list height setter
		getResultsBlockHeightShapeSignature () {
			let preparedTestResults = this.get('preparedTestResults') || [];
			let measurementsMetadata = this.get('measurementsMetadata') || {};
			let measurementIds = Object.keys(measurementsMetadata)
				.sort()
				.map(key => measurementsMetadata[key]?.measurementId || '')
				.join(',');
			let expectedTargetsCnt = this.get('targetsCnt') || preparedTestResults[0]?.statsPerTarget?.length || 0;

			return `${measurementIds}:${expectedTargetsCnt}:${preparedTestResults.length}`;
		},
		shouldAllowResultsBlockShrink () {
			if (!this.get('allowResultsBlockShrink')) {
				return false;
			}

			let currentSignature = this.getResultsBlockHeightShapeSignature();
			let previousSignature = this.get('resultsBlockHeightShapeSignature');

			this.set('resultsBlockHeightShapeSignature', currentSignature);

			return currentSignature !== previousSignature;
		},
		setResultsBlockHeight ({ allowShrink = true } = {}) {
			if (!this.get('allowResultsBlockShrink')) {
				return;
			}

			this.pendingResultsBlockHeightAllowShrink = this.pendingResultsBlockHeightFrame
				? this.pendingResultsBlockHeightAllowShrink && allowShrink
				: allowShrink;

			if (this.pendingResultsBlockHeightFrame) {
				return;
			}

			this.pendingResultsBlockHeightFrame = requestAnimationFrame(() => {
				let pendingAllowShrink = this.pendingResultsBlockHeightAllowShrink;
				this.pendingResultsBlockHeightAllowShrink = false;
				this.pendingResultsBlockHeightFrame = null;

				let listEl;

				try {
					listEl = this.find('.c-gp-results-raw-output_list');
				} catch {
					return;
				}

				if (listEl) {
					let currentHeight = parseFloat(listEl.style.height) || 0;
					let currentScrollTop = listEl.scrollTop;

					let items = listEl.querySelectorAll('.c-gp-results-raw-output_list_item');
					let itemsAmount = items.length;

					if (itemsAmount === 0) {
						return;
					}

					let targetHeight = 0;
					let limit = Math.min(itemsAmount, 3);

					for (let i = 0; i < limit; i++) {
						targetHeight += items[i].offsetHeight;
					}

					let totalItemHeight = targetHeight;

					for (let i = limit; i < itemsAmount; i++) {
						totalItemHeight += items[i].offsetHeight;
					}

					targetHeight = Math.ceil(targetHeight);
					totalItemHeight = Math.ceil(totalItemHeight);

					if (MIN_OUTPUT_HEIGHT > targetHeight && MIN_OUTPUT_HEIGHT <= totalItemHeight) {
						targetHeight = MIN_OUTPUT_HEIGHT;
					}

					// Collapse-only updates keep the current height; structural updates may shrink empty space.
					let shouldUpdateHeight = targetHeight > currentHeight
						|| (pendingAllowShrink && targetHeight !== currentHeight && totalItemHeight < currentHeight);

					if (shouldUpdateHeight) {
						listEl.style.height = `${targetHeight}px`;
					}

					if (listEl.scrollTop !== currentScrollTop) {
						listEl.scrollTop = currentScrollTop;
					}
				}
			});
		},
		// --- Logic to determine whether to wrap the header info ---
		// First, calculate current character widths for the font used in the header info
		// Then, use these widths to calculate the width of the header info text for each entity
		// If one entity takes up too much space, wrap the header info
		// Recalculate the overflow states for each entity on window resize
		initHeaderInfoCharWidths () {
			let measureNode = document.createElement('span');
			measureNode.className = 'c-gp-results-raw-output_list_item_header_info_entity_field';
			measureNode.style.position = 'absolute';
			measureNode.style.visibility = 'hidden';
			measureNode.style.whiteSpace = 'pre';
			measureNode.style.pointerEvents = 'none';
			measureNode.style.display = 'inline-block';
			measureNode.style.margin = '0';
			measureNode.style.padding = '0';
			measureNode.style.border = '0';
			measureNode.style.letterSpacing = 'normal';
			measureNode.style.fontFamily = 'Lexend, sans-serif';
			measureNode.style.fontSize = '13px';
			measureNode.style.fontWeight = '400';
			measureNode.textContent = 'M';
			document.body.appendChild(measureNode);

			let fallbackCharWidth = measureNode.getBoundingClientRect().width || 7;
			this.set('headerInfoFallbackCharWidth', fallbackCharWidth);

			let cacheKey = 'header-char-widths';
			let cached = null;

			try {
				cached = JSON.parse(sessionStorage.getItem(cacheKey) || '{}');
			} catch {
				cached = {};
			}

			if (Object.keys(cached).length === 256) {
				measureNode.remove();
				this.set('headerInfoCharWidths', cached);
				return;
			}

			let charWidths = Object.create(null);
			let basePairWidth = 0;
			let noSpacePairWidth = 0;

			measureNode.textContent = 'a a';
			basePairWidth = measureNode.getBoundingClientRect().width || 0;
			measureNode.textContent = 'aa';
			noSpacePairWidth = measureNode.getBoundingClientRect().width || 0;

			for (let charCode = 0; charCode <= 255; charCode++) {
				if (charCode === 32) {
					charWidths[charCode] = (basePairWidth - noSpacePairWidth) || (fallbackCharWidth * 0.5);
					continue;
				}

				measureNode.textContent = String.fromCharCode(charCode);
				charWidths[charCode] = measureNode.getBoundingClientRect().width || fallbackCharWidth;
			}

			try {
				sessionStorage.setItem(cacheKey, JSON.stringify(charWidths));
			} catch {
				// ignore storage errors
			}

			measureNode.remove();
			this.set('headerInfoCharWidths', charWidths);
		},
		measureHeaderInfoTextWidth (value = '') {
			let charWidths = this.get('headerInfoCharWidths');
			let fallbackCharWidth = this.get('headerInfoFallbackCharWidth');
			let text = String(value ?? '');
			let totalWidth = 0;

			for (let i = 0; i < text.length; i++) {
				let charCode = text.charCodeAt(i);
				totalWidth += charWidths[charCode] ?? fallbackCharWidth;
			}

			return totalWidth;
		},
		getHeaderInfoSourceEntityWidth (result) {
			let asnText = `AS${result?.asn ?? ''}`;
			let locationText = [ result?.city, result?.state, result?.country ].filter(Boolean).join(', ');
			let networkText = result?.network || '';
			let fieldsTextWidth = this.measureHeaderInfoTextWidth(asnText) + this.measureHeaderInfoTextWidth(locationText) + this.measureHeaderInfoTextWidth(networkText);
			let iconWidths = 16 + 21 + 18;
			let textIconGaps = 6 * 3;
			let fieldsGap = 16 * 2;
			let entityHorizontalPadding = 8 * 2;

			return fieldsTextWidth + iconWidths + textIconGaps + fieldsGap + entityHorizontalPadding;
		},
		getHeaderInfoTargetEntityWidth (result) {
			let activeTargetIdx = this.get('activeTargetIdx');
			let ipAddr = result?.statsPerTarget?.[activeTargetIdx]?.ipAddr;

			if (!ipAddr) {
				return 0;
			}

			let ipTextWidth = this.measureHeaderInfoTextWidth(ipAddr);
			let locationLabel = this.isAnycastIp(ipAddr) ? 'Anycast' : this.getIpLocationLabel(ipAddr) || '';
			let hasLocationField = !!locationLabel;
			let locationTextWidth = hasLocationField ? this.measureHeaderInfoTextWidth(locationLabel) : 0;
			let networkName = this.getNetworkName(ipAddr) || '';
			let networkTextWidth = this.measureHeaderInfoTextWidth(networkName);
			let isNetworkInfoLoading = this.isTargetNetworkInfoLoading(ipAddr);
			let hasLocationPlaceholder = !hasLocationField && isNetworkInfoLoading;
			let hasNetworkPlaceholder = !networkName && isNetworkInfoLoading;
			let loadingPlaceholderWidth = 77 * ((hasLocationPlaceholder ? 1 : 0) + (hasNetworkPlaceholder ? 1 : 0));
			let fieldCount = 1 + (hasLocationField ? 1 : 0) + (networkName ? 1 : 0) + (hasLocationPlaceholder ? 1 : 0) + (hasNetworkPlaceholder ? 1 : 0);
			let hasLocationIcon = this.isAnycastIp(ipAddr) || !!this.getIpLocationCountryCode(ipAddr);
			let locationIconWidth = hasLocationField ? this.isAnycastIp(ipAddr) ? 22 : this.getIpLocationCountryCode(ipAddr) ? 21 : 0 : 0;
			let iconCount = 1 + (hasLocationIcon ? 1 : 0) + (networkName ? 1 : 0);
			let iconWidths = 16 + locationIconWidth + (networkName ? 18 : 0);
			let textIconGaps = iconCount * 6;
			let fieldsGap = 16 * Math.max(fieldCount - 1, 0);
			let entityHorizontalPadding = 8 * 2;

			return ipTextWidth + locationTextWidth + networkTextWidth + loadingPlaceholderWidth + iconWidths + textIconGaps + fieldsGap + entityHorizontalPadding;
		},
		getHeaderInfoEntityWidthCacheKey (result, activeTargetIdx = this.get('activeTargetIdx')) {
			return `${activeTargetIdx}:${result?.clientSideId ?? ''}`;
		},
		resetHeaderInfoEntityWidthCache (ipAddresses = null) {
			if (ipAddresses === null) {
				this.set('headerInfoEntityWidthsByKey', new Map());
				return;
			}

			if (ipAddresses.length === 0) {
				return;
			}

			let activeTargetIdx = this.get('activeTargetIdx');
			let ipAddressSet = new Set(ipAddresses);
			let preparedTestResults = this.get('preparedTestResults') || [];
			let headerInfoEntityWidthsByKey = this.get('headerInfoEntityWidthsByKey');

			preparedTestResults.forEach((result) => {
				let ipAddr = result?.statsPerTarget?.[activeTargetIdx]?.ipAddr;

				if (ipAddressSet.has(ipAddr)) {
					headerInfoEntityWidthsByKey.delete(this.getHeaderInfoEntityWidthCacheKey(result));
				}
			});
		},
		getHeaderInfoEntityWidths (result) {
			let cacheKey = this.getHeaderInfoEntityWidthCacheKey(result);
			let headerInfoEntityWidthsByKey = this.get('headerInfoEntityWidthsByKey');
			let cached = headerInfoEntityWidthsByKey.get(cacheKey);

			if (cached) {
				return cached;
			}

			let target = this.getHeaderInfoTargetEntityWidth(result);
			let source = target ? this.getHeaderInfoSourceEntityWidth(result) : 0;
			let widths = { target, source };

			headerInfoEntityWidthsByKey.set(cacheKey, widths);

			return widths;
		},
		recalculateHeaderInfoLayoutStates ({ allowShrink = true } = {}) {
			let listEl = this.find('.c-gp-results-raw-output_list');
			let listWidth = listEl?.offsetWidth || 0;
			let preparedTestResults = this.get('preparedTestResults') || [];
			let previousListWidth = this.get('headerInfoListWidth') || 0;
			let headerInfoEntityWidthsByKey = this.get('headerInfoEntityWidthsByKey');
			let shouldRecalculateCachedOverflow = listWidth !== previousListWidth || headerInfoEntityWidthsByKey.size === 0;

			let previousOverflowByResultId = this.get('headerInfoOverflowByResultId') || new Set();
			let overflowByResultId = shouldRecalculateCachedOverflow
				? new Set()
				: new Set(previousOverflowByResultId);

			let didUpdateOverflow = shouldRecalculateCachedOverflow;

			if (shouldRecalculateCachedOverflow) {
				this.set('headerInfoListWidth', listWidth);
			}

			let availableHalfWidth = this.get('headerInfoAvailableHalfWidth');

			preparedTestResults.forEach((result) => {
				let resultId = result.clientSideId;
				let wasWidthCached = headerInfoEntityWidthsByKey.has(this.getHeaderInfoEntityWidthCacheKey(result));
				let widths = this.getHeaderInfoEntityWidths(result);
				let targetEntityWidth = widths.target;

				if (!targetEntityWidth) {
					if (overflowByResultId.has(resultId)) {
						overflowByResultId.delete(resultId);
						didUpdateOverflow = true;
					}

					return;
				}

				if (wasWidthCached && !shouldRecalculateCachedOverflow) {
					return;
				}

				let sourceEntityWidth = widths.source;
				let shouldUseOverflowLayout = sourceEntityWidth > availableHalfWidth || targetEntityWidth > availableHalfWidth;

				if (overflowByResultId.has(resultId) !== shouldUseOverflowLayout) {
					didUpdateOverflow = true;
				}

				if (shouldUseOverflowLayout) {
					overflowByResultId.add(resultId);
				} else {
					overflowByResultId.delete(resultId);
				}
			});

			if (didUpdateOverflow) {
				this.set('headerInfoOverflowByResultId', overflowByResultId);
			}

			this.setResultsBlockHeight({ allowShrink });
		},
		shouldUseOverflowLayout (result) {
			let overflowByResultId = this.get('headerInfoOverflowByResultId') || new Set();
			return overflowByResultId.has(result?.clientSideId);
		},
		recalculateHeaderInfoLayoutStatesAfterNetworkLookup () {
			if (this.get('pendingNetworkLookups').size > 0) {
				return;
			}

			if (this.pendingNetworkDataUpdatesFlushTimeout) {
				clearTimeout(this.pendingNetworkDataUpdatesFlushTimeout);
				this.pendingNetworkDataUpdatesFlushTimeout = null;
			}

			this.resetHeaderInfoEntityWidthCache(this.flushNetworkDataUpdates());
			this.recalculateHeaderInfoLayoutStates({ allowShrink: false });
		},
		// --- Fetching and caching network data + related getters ---
		queueNetworkDataByIp (ipAddr, networkData) {
			if (!this.get('networkLookupsActive')) {
				return;
			}

			this.pendingNetworkDataUpdatesByIp = this.pendingNetworkDataUpdatesByIp || new Map();
			this.pendingNetworkDataUpdatesByIp.set(ipAddr, networkData);
			this.scheduleNetworkDataUpdatesFlush();
		},
		scheduleNetworkDataUpdatesFlush () {
			if (!this.get('networkLookupsActive')) {
				return;
			}

			if (this.pendingNetworkDataUpdatesFlushTimeout) {
				return;
			}

			this.pendingNetworkDataUpdatesFlushTimeout = setTimeout(() => {
				if (!this.get('networkLookupsActive')) {
					return;
				}

				this.pendingNetworkDataUpdatesFlushTimeout = null;
				this.resetHeaderInfoEntityWidthCache(this.flushNetworkDataUpdates());
				this.recalculateHeaderInfoLayoutStates({ allowShrink: false });
			}, 500);
		},
		flushNetworkDataUpdates () {
			let networkDataUpdatesByIp = this.pendingNetworkDataUpdatesByIp || new Map();
			let hasIpUpdates = networkDataUpdatesByIp.size > 0;

			if (hasIpUpdates) {
				this.set('networkDataByIp', {
					...this.get('networkDataByIp'),
					...Object.fromEntries(networkDataUpdatesByIp),
				});

				this.pendingNetworkDataUpdatesByIp = new Map();
			}

			if (hasIpUpdates) {
				this.set('showingNetworkLogos', this.get('showingNetworkLogos') || Array.from(networkDataUpdatesByIp.values()).some(networkData => !!networkData?.asn));
			}

			return Array.from(networkDataUpdatesByIp.keys());
		},
		populateNetworkData () {
			let preparedTestResults = this.get('preparedTestResults') || [];
			let activeTargetIdx = this.get('activeTargetIdx');
			let ipAddresses = new Set();

			preparedTestResults.forEach((result) => {
				let ipAddr = result?.statsPerTarget?.[activeTargetIdx]?.ipAddr;

				if (ipAddr) {
					ipAddresses.add(ipAddr);
				}
			});

			for (let ipAddr of ipAddresses) {
				this.fetchNetworkByIp(ipAddr);
			}
		},
		fetchNetworkByIp (ipAddr) {
			let networkDataByIp = this.get('networkDataByIp');
			let pendingNetworkLookups = this.get('pendingNetworkLookups');

			if (!ipAddr || Object.hasOwn(networkDataByIp, ipAddr) || pendingNetworkLookups.has(ipAddr)) {
				return;
			}

			pendingNetworkLookups.add(ipAddr);
			this.update('pendingNetworkLookups');

			http.getNetworkFromIP(ipAddr)
				.then((res) => {
					if (!this.get('networkLookupsActive')) {
						return;
					}

					this.queueNetworkDataByIp(ipAddr, res);
				})
				.catch(() => {
					if (!this.get('networkLookupsActive')) {
						return;
					}

					this.queueNetworkDataByIp(ipAddr, null);
				})
				.finally(() => {
					if (!this.get('networkLookupsActive')) {
						return;
					}

					pendingNetworkLookups.delete(ipAddr);
					this.recalculateHeaderInfoLayoutStatesAfterNetworkLookup();
				});
		},
		getNetworkDataByIp (ipAddr) {
			return ipAddr ? this.get('networkDataByIp')[ipAddr] : null;
		},
		getNetworkAsnByIp (ipAddr) {
			let network = this.getNetworkDataByIp(ipAddr);
			return network?.asn || null;
		},
		getNetworkName (ipAddr) {
			let network = this.getNetworkDataByIp(ipAddr);
			return network?.name || network?.domain || null;
		},
		isTargetNetworkInfoLoading (ipAddr) {
			return this.get('pendingNetworkLookups').has(ipAddr);
		},
		getLocationByIp (ipAddr) {
			return this.getNetworkDataByIp(ipAddr)?.location || null;
		},
		isAnycastIp (ipAddr) {
			return this.getLocationByIp(ipAddr)?.isAnycast || false;
		},
		getIpLocationCountryCode (ipAddr) {
			return this.getLocationByIp(ipAddr)?.country || null;
		},
		getIpLocationLabel (ipAddr) {
			let location = this.getLocationByIp(ipAddr);

			if (!location || location.isAnycast) {
				return null;
			}

			let values = [ location.city, location.state, location.country ].filter(Boolean);
			return values.length ? values.join(', ') : null;
		},
		shouldRenderTargetNetwork (ipAddr) {
			return this.getNetworkAsnByIp(ipAddr) && this.getNetworkName(ipAddr);
		},
		logoError (logoKey) {
			return this.get('logoErrors').has(logoKey);
		},
		setLogoError (logoKey) {
			this.get('logoErrors').add(logoKey);
			this.update('logoErrors');
		},
		// --- Other functions ---
		getStatusColor (targetStats) {
			if (targetStats.extraValues?.errorStatus) {
				return _.getGpProbeStatusColor(targetStats.extraValues.errorStatus);
			}

			return _.getGpProbeStatusColor(targetStats.avgTiming, this.get('testReqParams').type === 'http' ? 1000 : 200);
		},
		getHeaderPrimaryMetrics (extraValues = {}) {
			return [
				extraValues.dnsStatus,
				extraValues.httpStatus,
				extraValues.answers,
			].filter(Boolean);
		},
		getHeaderSecondaryMetrics (extraValues = {}) {
			return Object.keys(extraValues)
				.filter(key => ![ 'answers', 'dnsStatus', 'httpStatus', 'errorStatus' ].includes(key))
				.map(key => extraValues[key])
				.filter(Boolean);
		},
		hideShowTestResult (resultId) {
			let activeTargetIdx = this.get('activeTargetIdx');
			let hidden = this.get(`hiddenTestResults[${activeTargetIdx}]`) ?? [];
			let hiddenContent = this.get(`hiddenResponseBodies[${activeTargetIdx}]`) ?? [];
			let preparedTestResults = this.get('preparedTestResults') || [];
			let result = preparedTestResults.find(item => item.clientSideId === resultId);
			let body = result?.statsPerTarget?.[activeTargetIdx]?.responseBody || '';
			let isOpening = hidden.includes(resultId);

			let updated = isOpening
				? hidden.filter(clientSideId => clientSideId !== resultId)
				: [ ...hidden, resultId ];

			this.set(`hiddenTestResults[${activeTargetIdx}]`, updated);

			// Reset the content state when closing output, but keep the current response-body state when opening it.
			if (!isOpening && !hiddenContent.includes(resultId) && _.shouldCollapseResponseBody(body, this.get('responseBodyCharsPerLine'))) {
				this.set(`hiddenResponseBodies[${activeTargetIdx}]`, [ ...hiddenContent, resultId ]);
			}
		},
	};
</script>
